import { Fragment } from 'react';
import { useFormDetailsQuery } from '../../lib/Queries';
import Select from '../Select';
import { getConditionalQuestions } from '../../lib/FormHelpers.js';
import { truncate } from '../../lib/Utils.js';
import { useBookableResourcesQuery } from '~/lib/SharedQueries';
import { useQuestionEventTypes } from '~/components/forms/questions/scheduling/SelectEventType';
import ErrorMessage from '~/components/ErrorMessage';

const SectionConditional = ({ section, conditional, setConditional }) => {
    const { data, isLoading } = useFormDetailsQuery(section.form_id);

    const formSections = data?.formSections || [];

    const sectionQuestions = (data?.sections || []).filter(
        s => s.section.id === section.id,
    )[0]?.questions;

    const { types } = useQuestionEventTypes(null, null, true);
    const { data: bookableResourcesData } = useBookableResourcesQuery();

    const conditionalQuestions = getConditionalQuestions(
        sectionQuestions,
        data?.schema,
        types,
        bookableResourcesData,
    );

    const sectionOptions = {};
    let hasSeenOurSection = false;
    formSections.forEach((sectionData, idx) => {
        if (sectionData.section.id === section.id) {
            hasSeenOurSection = true;
            return;
        } else if (!hasSeenOurSection) {
            return;
        }

        const firstQuestion =
            sectionData.questions.length > 0
                ? truncate(sectionData.questions[0].label, 30)
                : null;

        sectionOptions['jump-' + sectionData.section.id] =
            `Go to section ${idx + 1}${firstQuestion ? ` (${firstQuestion})` : ''}`;
    });

    let options = {};

    const hasNextSection = Object.keys(sectionOptions).length > 0;
    if (hasNextSection) {
        options[''] = 'Continue to the next section';
    }

    options = {
        ...options,
        ...sectionOptions,
        submit: 'Submit the form',
    };

    const mainOptions = {
        ...options,
        ...(conditionalQuestions.length > 0 && hasNextSection
            ? { condition: 'Go to a different section based on answer' }
            : {}),
    };

    const conditionalQuestionsOptions = {};
    conditionalQuestions.forEach(q => {
        conditionalQuestionsOptions[q.id] = q.label;
    });

    const matchingConditionalQuestions = conditionalQuestions.filter(
        q => q.id == conditional?.question,
    );
    const matchingConditionalQuestion = matchingConditionalQuestions[0] || {};
    if (Object.keys(matchingConditionalQuestion).length === 0) {
        conditionalQuestionsOptions[conditional?.question] =
            'Unknown Question (Please select a different question)';
    }

    const optionsForSelectedQuestion =
        matchingConditionalQuestion.optionLabels ||
        matchingConditionalQuestion.options?.reduce((map, o) => {
            return {
                ...map,
                [o]: o,
            };
        }, {}) ||
        {};

    return (
        <div>
            <div className="flex items-center ml-4">
                <span className="mr-1">After this section</span>
                <select
                    value={conditional?.goto}
                    onChange={ev =>
                        setConditional({
                            ...conditional,
                            goto: ev.target.value,
                        })
                    }
                    className="bg-transparent padding-0 border-0 text-primary-700 padding-0 focus:outline-0 focus:ring-0"
                >
                    {Object.keys(mainOptions).map(key => (
                        <option value={key} key={key}>
                            {mainOptions[key]}
                        </option>
                    ))}
                </select>
            </div>

            {conditional?.goto === 'condition' && (
                <div className="-mt-2 ml-4 mb-8">
                    {conditionalQuestions.length > 0 && (
                        <Select
                            value={conditional?.question || ''}
                            onChange={newValue =>
                                setConditional({
                                    ...conditional,
                                    question: newValue,
                                })
                            }
                            options={conditionalQuestionsOptions}
                            inputClassName="focus:ring-0 bg-transparent border-0 text-gray-500"
                        />
                    )}
                    {conditionalQuestions.length === 0 && (
                        <div className="text-red-700">
                            Error, there are no questions with options
                        </div>
                    )}

                    {conditionalQuestions.length > 0 && (
                        <div className="bg-gray-200 rounded-lg p-6 grid grid-cols-3 items-center gap-y-2">
                            {Object.keys(optionsForSelectedQuestion).length ===
                                0 && (
                                <ErrorMessage>
                                    There are no options, please choose a
                                    different question
                                </ErrorMessage>
                            )}
                            {Object.keys(optionsForSelectedQuestion).map(
                                (answer, idx) => (
                                    // <div
                                    //     key={answer}
                                    //     className={`flex items-center ${idx > 0 ? 'pt-4' : ''}`}
                                    // >
                                    <Fragment key={answer}>
                                        <div className=" mr-2 min-w-16 font-semibold">
                                            {optionsForSelectedQuestion[answer]}
                                        </div>
                                        <div className="col-span-2">
                                            <Select
                                                value={
                                                    (conditional?.answerGoto ||
                                                        [])[
                                                        answer.toLowerCase()
                                                    ] || ''
                                                }
                                                onChange={value =>
                                                    setConditional({
                                                        ...conditional,
                                                        answerGoto: {
                                                            ...conditional?.answerGoto,
                                                            [answer.toLowerCase()]:
                                                                value,
                                                        },
                                                    })
                                                }
                                                options={options}
                                            />
                                        </div>
                                    </Fragment>
                                ),
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SectionConditional;
